import { render, staticRenderFns } from "./other-contact.vue?vue&type=template&id=2d9b01a5&"
import script from "./other-contact.vue?vue&type=script&lang=js&"
export * from "./other-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports